module.exports = __webpack_public_path__ + "static/paquete-1-a014b6419e51ac3c9dd0381dc808cbab.svg";